// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3iGs4","itemTitle":"ClientEmergencyInfo_itemTitle__3_NY0","itemText":"ClientEmergencyInfo_itemText__38wD5"};